<script setup lang="ts">
    import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/shared/ui/organisms/Command';
    import UiIcon from '@/components/Global/UiIcon/UiIcon.vue';
    import { useSidebarLinks } from '../../composables/use-sidebar-links';
    import { toCommandGroups, type CommandLink } from './command-links';

    const { t } = useI18n();
    // The sidebar labels are keys of the global locale
    const { t: globalT } = useI18n({ useScope: 'global' });
    const router = useRouter();
    const { items } = useSidebarLinks();

    const groups = computed(() => toCommandGroups(items.value, globalT));

    function navigate(link: CommandLink) {
        router.push(link.to);
    }
</script>

<template>
    <CommandDialog :aria-label="t('NAVIGATION_MENU')">
        <CommandInput :placeholder="t('SEARCH_PLACEHOLDER')" />
        <CommandList>
            <CommandEmpty>{{ t('NOTHING_FOUND') }}</CommandEmpty>
            <CommandGroup
                v-for="group in groups"
                :key="group.heading ?? ''"
                :heading="group.heading ?? t('PAGES')"
            >
                <CommandItem
                    v-for="link in group.links"
                    :key="link.value"
                    :value="link.value"
                    @select="navigate(link)"
                >
                    <UiIcon
                        v-if="link.icon"
                        :icon="link.icon"
                        :size="16"
                        color="secondary-gray"
                    />
                    {{ link.label }}
                </CommandItem>
            </CommandGroup>
        </CommandList>
    </CommandDialog>
</template>

<i18n lang="yaml">
en:
    NAVIGATION_MENU: Go to page
    SEARCH_PLACEHOLDER: Search pages…
    NOTHING_FOUND: No pages found
    PAGES: Pages
nl:
    NAVIGATION_MENU: Ga naar pagina
    SEARCH_PLACEHOLDER: Zoek pagina's…
    NOTHING_FOUND: Geen pagina's gevonden
    PAGES: Pagina's
</i18n>
